export default "https://0f174046-a3c4-46d7-88af-9cfef9e6bcb2.selcdn.net/webpack/production/8e5b2c2f851c877515052b4ebb29d049.jpg";